interface InactivateFileProps {
  width?: string;
  height?: string;
}

function InactivateFile({ width = '34', height = '34' }: InactivateFileProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 34 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 3.75C0 1.68164 1.68164 0 3.75 0H13.125V7.5C13.125 8.53711 13.9629 9.375 15 9.375H22.5V11.6367C18.1699 12.8613 15 16.8398 15 21.5625C15 25.0254 16.7051 28.084 19.3184 29.959C19.1309 29.9883 18.9434 30 18.75 30H3.75C1.68164 30 0 28.3184 0 26.25V3.75ZM22.5 7.5H15V0L22.5 7.5Z" />
      <circle cx="25.3125" cy="21.5625" r="8.4375" />
      <rect x="21.3125" y="20.5625" width="8" height="2" rx="1" fill="white" />
    </svg>
  );
}

export default InactivateFile;
